var _desc, _defs, _rect, _path, _rect2, _path2, _path3, _text, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStorefrontBottledWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 420",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Bottled water") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A clear plastic bottled water with a blue label and cap.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottle",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b8e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fdcf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "water",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcefff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ec9f3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 420,
    fill: "#f8fafc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 20h60v52c0 11 6 22 15 29 20 16 33 42 33 70v181c0 32-26 58-58 58h-40c-32 0-58-26-58-58V171c0-28 13-54 33-70 9-7 15-18 15-29V20z",
    fill: "url(#bottle)",
    stroke: "#7bc8e7",
    strokeWidth: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 8,
    width: 72,
    height: 42,
    rx: 10,
    fill: "#1877c9",
    stroke: "#0f5f9f",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 206h144v94H88z",
    fill: "#1677c8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 300h144v28H88z",
    fill: "#0e5fa4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 254,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#ffffff"
  }, "WATER")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96 170c27 15 45 15 72 0s45-15 62 0v175c0 25-20 45-45 45h-50c-25 0-45-20-45-45V170z",
    fill: "url(#water)",
    opacity: 0.48
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116 108c-15 16-22 35-22 58v184c0 23 18 42 41 42",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 10,
    opacity: 0.65,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStorefrontBottledWater);
export default __webpack_public_path__ + "static/media/product_storefront_bottled_water.57a3ea9d04e17520710baa92f93e3f74.svg";
export { ForwardRef as ReactComponent };